import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  setBizID,
  setStyle,
  setLogo,
  setBackground,
  setBusinessName,
} from "../../libs/todoSlice";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra`;

/**
 * ดึงข้อมูล business ของ prefix (logo, theme, ชื่อ, services)
 * ไม่ guard service เอง ให้ RegisterRoute เป็นคนเลือกหน้าตาม services
 */
export default function useRegisterPrefix() {
  const { prefix } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [services, setServices] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${BASE}/prefix`, { params: { prefix } });
        if (!data.data) {
          navigate("/notfound");
          return;
        }

        const bizId = data.data.businessID;
        dispatch(setBizID({ biz_id: bizId }));
        dispatch(setStyle({ style: data.data.themes.style }));
        dispatch(setBusinessName({ business_name: data.data.businessName }));

        // ไม่มี logo / background ก็ปล่อยให้ fallback เป็นค่า default
        axios
          .get(`${BASE}/logo`, { params: { business_id: bizId } })
          .then(({ data }) => dispatch(setLogo({ logo: data.data })))
          .catch(() => {});
        axios
          .get(`${BASE}/background`, { params: { business_id: bizId } })
          .then(({ data }) => dispatch(setBackground({ background: data.data })))
          .catch(() => {});

        setServices(data.data.services || []);
        setReady(true);
      } catch (error) {
        navigate("/notfound");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix]);

  return { prefix, services, ready };
}